import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axiosInstance from '../config/axios';
import './Login.css';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect if not authenticated or if password change is not required
  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate('/login', { replace: true });
      } else if (!user.mustChangePassword) {
        // User doesn't need to change password, redirect to their dashboard
        const roleRoutes = {
          power_user: '/power-user',
          admin: '/admin',
          manager: '/manager',
          site: '/site'
        };
        navigate(roleRoutes[user.role] || '/login', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters long');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirmation do not match');
      return;
    }

    try {
      await axiosInstance.post('/api/auth/change-password', {
        currentPassword,
        newPassword
      });

      setSuccess('Password changed successfully! Redirecting...');
      
      // Refresh user data and redirect after a short delay
      setTimeout(() => {
        // Redirect based on role
        const roleRoutes = {
          power_user: '/power-user',
          admin: '/admin',
          manager: '/manager',
          site: '/site'
        };
        navigate(roleRoutes[user?.role] || '/login', { replace: true });
        // Force page reload to refresh user data
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error('Change password error:', error);
      setError(error.response?.data?.error || 'Failed to change password. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo-container">
          <img 
            src={`${process.env.PUBLIC_URL || ''}/logo.png`} 
            alt="SimplyInventory Logo" 
            className="login-logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
        <h1>SimplyInventory</h1>
        <h2>Change Password Required</h2>
        <p style={{ marginBottom: '20px', color: '#666', textAlign: 'center' }}>
          Your password was reset by an administrator, or you must set a new password before continuing.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
            />
            <small style={{ display: 'block', marginTop: '5px', color: 'var(--hana-grey)' }}>
              Must be at least 6 characters long
            </small>
          </div>
          <div className="form-group">
            <label>Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>
          {error && <div className="error">{error}</div>}
          {success && <div className="success">{success}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
